import { useState } from 'react';
import { addBarcode } from '../api/manifests-api';

interface AddBarcodeInputProps {
  manifestId: number;
  onAdded: () => void;
}

export function AddBarcodeInput({ manifestId, onAdded }: AddBarcodeInputProps) {
  const [barcodeValue, setBarcodeValue] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      const response = await addBarcode(manifestId, { barcodeValue });
      if (response.success) {
        setBarcodeValue('');
        onAdded();
      } else {
        setError(response.message || 'Failed to add barcode');
      }
    } catch {
      setError('An error occurred while adding barcode');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="flex items-end gap-3">
      <div className="flex-1">
        <label htmlFor="barcodeValue" className="block text-sm font-medium mb-2">
          Add Single Barcode
        </label>
        <input
          id="barcodeValue"
          type="text"
          value={barcodeValue}
          onChange={(e) => setBarcodeValue(e.target.value)}
          className="w-full px-4 py-2 rounded bg-gray-700 border border-gray-600 focus:border-blue-500 focus:outline-none"
          placeholder="Enter barcode value"
        />
      </div>
      <button
        type="submit"
        disabled={isLoading || !barcodeValue.trim()}
        className="px-4 py-2 text-sm bg-green-600 hover:bg-green-700 disabled:bg-green-800 disabled:cursor-not-allowed rounded transition-colors"
      >
        {isLoading ? 'Adding...' : 'Add'}
      </button>
      {error && <span className="text-red-500 text-sm">{error}</span>}
    </form>
  );
}
